import React, { useState, forwardRef, useEffect } from "react";

import { InputText } from "primereact/inputtext";
import { InputTextarea } from "primereact/inputtextarea";
import MeaUpdateModal from "../../../../components/MeaUpdateModal";
import coursesAPI from "../../../../services/courses";

const UpdateCourseModal = forwardRef((props, ref) => {
  //
  const [name, setName] = useState("");
  const [presentation, setPresentation] = useState("");
  const [levelName, setLevelName] = useState("");

  //
  useEffect(() => {
    setName(props?.course?.name);
    setPresentation(props?.course?.presentation);
    setLevelName(props?.course?.level?.name)
  }, [props]);
  //
  return (
    <>
      <MeaUpdateModal
        ref={ref}
        title="Editer la matière"
        schoolId={props.schoolId}
        trainingId={props.trainingId}
        serviceAPI={coursesAPI}
        id={props?.course?.id}
        data={{
          name: name,
          presentation: presentation,
        }}
      >
        <label htmlFor="name" className="block text-900 font-medium mb-2">
          Nom de la matière
        </label>
        <InputText
          id="name"
          type="text"
          value={name}
          onChange={(e) => setName(e.target.value)}
          className="w-full mb-3"
          autoFocus
        />
        <label
          htmlFor="presentation"
          className="block text-900 font-medium mb-2"
        >
          Présentation
        </label>
        <InputTextarea
          id="presentation"
          type="text"
          value={presentation}
          onChange={(e) => setPresentation(e.target.value)}
          rows={3}
          className="w-full mb-3"
        />
        <label htmlFor="name" className="block text-900 font-medium mb-2">
          Niveau de la matière
        </label>
        <InputText
          id="name"
          type="text"
          value={levelName}
          onChange={(e) => setName(e.target.value)}
          className="w-full mb-3"
          disabled={true}
        />

      </MeaUpdateModal>
    </>
  );
});

export default UpdateCourseModal;
